<template>
  <div class="">
    <Modal
      v-model="robotModal"
      width="600"
      :title="distriServeTitle"
      :mask-closable="false"
      :transfer="false"
      :loading="loading"
      @on-ok="distriServeList('robotForm')"
    >
			<Form
        ref="robotForm"
        :model="robotForm"
        :rules="ruleValidate"
        :label-width="100"
        label-position="right"
      >
        <FormItem label="机器人名称："
          prop="name"
          label-for="name"
        >
          <Input
            placeholder="请输入机器人名称"
            element-id="name"
            v-model="robotForm.name"
          />
        </FormItem>
        <FormItem label="Webhook："
          prop="webhook_url"
          label-for="webhook_url"
        >
          <Input
            placeholder="请输入Webhook"
            element-id="webhook_url"
            v-model="robotForm.webhook_url"
          />
        </FormItem>
        <FormItem label="加签："
          prop="secret"
          label-for="secret"
        >
          <Input
            placeholder="请输入加签"
            element-id="secret"
            v-model="robotForm.secret"
          />
        </FormItem>
        <FormItem label="群组绑定企业："
          prop="epId"
          label-for="epId"
        >
          <!-- <Input
            placeholder="请输入群组绑定企业"
            element-id="epId"
            v-model="robotForm.epId"
          /> -->
          <ModalSelect v-model="robotForm.epId"  @on-change="getEpId" title="企业" />
        </FormItem>
        <FormItem label="备注：">
          <Input v-model="robotForm.remarks" type="textarea" :rows="4" placeholder="请输入备注" />
        </FormItem>
        <FormItem label="是否启用："
          label-for="enable"
        >
				<Switch v-model="robotForm.enable"/>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import SmyDatePicker from '@/components/SmyDatePicker'
import ModalSelect from '@/components/ModalSelect'
export default {
  props: {
    agentId: {
      type: Number
    },
    distriServeTitle: {
      type: String
    },
    epIds: {
      type: [String, Number]
    },
    distriServeModal: {
      type: Boolean,
      required: true
    },
    distriServeRow: {
      type: Object
    }
  },
  components: {
    SmyDatePicker,
    ModalSelect
  },
  data () {
    return {
      loading: true,
      visible: false,
      robotModal: this.distriServeModal,
			robotForm: {
        name: '',
        webhook_url: '',
        is_sign: '1',
        secret: '',
        epId: '',
        remarks: '',
        enable: false
      },
      ruleValidate: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        webhook_url: [
          { required: true, message: '发送频率不能为空', trigger: 'blur' }
        ],
        secret: [
          { required: true, message: '加签不能为空', trigger: 'blur' }
        ]
        // epId: [
        //   { required: true, message: '群组绑定企业不能为空', trigger: 'blur' }
        // ]
      },
      // 日期配置 （无法选择今日之前的日期）
      dateDisabledOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      initepId: ''
    }
  },
  methods: {
   // 保存数据
    distriServeList (val) {
      let msg = ''
      let data = {}
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          this.robotForm.enable = this.robotForm.enable ? 1 : 0
          if (this.initepId !== '') {
            data = {
              ...this.robotForm,
              id: this.initepId
            }
            msg = '修改成功'
          } else {
            data = {
              id: '-1',
              ...this.robotForm
            }
            msg = '添加成功'
          }
          // return console.log(data, msg, 55)
          let url = '/robot/manage/save'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              this.$Message.success(msg)
              this.robotModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      if (this.distriServeRow) {
        this.initepId = this.distriServeRow.id
        let enable = false
        if (this.distriServeRow.enable === 1) {
            enable = true
        }
        this.robotForm = {
          name: this.distriServeRow.name,
          webhook_url: this.distriServeRow.webhook_url,
          secret: this.distriServeRow.secret,
          epId: this.distriServeRow.epId,
          remarks: this.distriServeRow.remarks,
          enable: enable,
          is_sign: this.distriServeRow.is_sign
        }
        // this.robotForm.name = this.distriServeRow.name
        // this.robotForm.webhook_url = this.distriServeRow.webhook_url.toString()
        // this.robotForm.enable = (this.distriServeRow.enable).toString()
      }
    },
    getEpId($event) {
      console.log($event)
    }
  },
  watch: {
    distriServeModal (val) {
      console.log(123)
      this.robotModal = val
      this.robotForm = {
        name: '',
        webhook_url: '',
        secret: '',
        epId: this.epIds,
        remarks: '',
        enable: false,
        is_sign: '1'
      }
      this.initepId = ''
      this.$refs['robotForm'].resetFields()
      if (val) {
        this.reload()
      }
    },
    robotModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/RobotSettings.vue